import React from 'react';
import AuthWrapComponent from '../components/AuthWrapComponent';
import useForm from "../utils/useForm";

const AuthWrap = () => {
  const {Component, title} = useForm();
  
  return (
      <AuthWrapComponent title={title}>
        <Component />
      </AuthWrapComponent>
  );
};

export default AuthWrap;